import {
    Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip, Card, CardHeader, CardContent, TableBody,
    Table, TableCell, TableRow, List, ListItem, ListItemIcon, Icon, IconButton, Collapse, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography
} from "@material-ui/core";
import { ArrowDropDown, ArrowRight, Close, ExpandMore } from "@material-ui/icons";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import { WidgetStore } from '../'
import ReactHtmlParser from "react-html-parser";
import { AlertController } from './Alerts';

const styles = createStyles({
    cardHeader: {
        backgroundColor: 'grey'
    }
});

@observer
class AlertsWidget extends React.Component<any> {

    public state = { showDetails: false };

    constructor(props: any) {
        super(props);
        WidgetStore.getAuthAlerts(authStore.currentUser.auth_id);
    }

    public handleAlertDismiss = (alert_rel_id: number) => {
        WidgetStore.authDismissAlert(alert_rel_id)
    }

    public render() {
        const { classes } = this.props;

        if (!WidgetStore.AlertsWidget.loaded) {
            return (
                <Paper style={{ width: "100%", height: "100%", overflow: 'auto' }}>
                    <Card style={{ height: "100%" }}>
                        <CardHeader title={'Alerts'} className={classes.cardHeader} />
                        <CardContent />
                    </Card>
                </Paper>
            )
        }

        return (
            // <Paper style={{ width: "100%", height: "100%", overflow: 'auto' }}>

            <Card style={{}}>
                <CardHeader title={'Alerts'} className={classes.cardHeader} />
                <CardContent>
                    {/* <List> */}
                    {WidgetStore.AlertsWidget.alerts.map((alert: any) => {
                        return (
                            <ExpansionPanel key={alert.alert_id}>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMore />}
                                    style={{ backgroundColor: 'rgba(0, 0, 0, .03)', borderBottom: '1px solid rgba(0, 0, 0, .125)' }}
                                >
                                    <Grid container={true} spacing={8}>
                                        <Grid item={true} xs={7}>
                                            <Typography variant='subtitle2'>{alert.AlertSubject}</Typography>
                                        </Grid>
                                        <Grid item={true} xs={4}>
                                            <Typography>{alert.WidgetDisplayDate}</Typography>

                                        </Grid>
                                        <Grid item={true} xs={1}>
                                            <IconButton style={{ margin: '0px', padding: '0px' }}
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onClick={(ev) => {ev.stopPropagation(); this.handleAlertDismiss(alert.alert_auth_rel_id)}}
                                            >
                                                <Close style={{ color: 'red' }} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <AlertController alert_row={alert} />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )
                    })}
                </CardContent>
            </Card>
            // </Paper>
        );
    }
}

export default withStyles(styles, { withTheme: true })(
    withRouter(AlertsWidget)
);


// WEBPACK FOOTER //
// ./src/modules/dashboard/Widgets/AlertsWidget.tsx